import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const LIGNES = [['energie_kj', 'Énergie', 'kJ'], ['energie_kcal', '', 'kcal'], ['matieres_grasses_g', 'Matières grasses', 'g'],
  ['acides_gras_satures_g', 'dont acides gras saturés', 'g'], ['glucides_g', 'Glucides', 'g'], ['sucres_g', 'dont sucres', 'g'],
  ['proteines_g', 'Protéines', 'g'], ['sel_g', 'Sel', 'g']];

export default function ELabelPage() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { axios.get(`${API}/api/etiquetage-vin/e-label/${id}`).then((r) => setV(r.data)).catch(() => setErr(true)); }, [id]);
  if (err) return <p className="p-8 text-center" data-testid="elabel-erreur">Vin introuvable.</p>;
  if (!v) return <p className="p-8 text-center">Chargement…</p>;
  return (
    <div className="min-h-screen bg-[#fbf8f1] px-5 py-8" data-testid="elabel-page">
      <div className="max-w-md mx-auto space-y-6">
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-stone-500">{v.producteur}</p>
          <h1 className="text-3xl font-serif text-[#5b1a2a] mt-2" data-testid="elabel-nom">{v.nom_cuvee}</h1>
          <p className="text-sm">{v.appellation} {v.millesime} · {v.tav} % vol · {v.volume_cl} cl</p>
        </div>
        <section><h2 className="font-semibold mb-1">Ingrédients</h2><p className="text-sm" data-testid="elabel-ingredients">{v.ingredients}</p>
          <p className="text-sm font-bold mt-1">Allergènes : contient des {v.allergenes.join(', ')}.</p></section>
        <section><h2 className="font-semibold mb-1">Déclaration nutritionnelle (pour 100 ml)</h2>
          <table className="w-full text-sm" data-testid="elabel-nutrition"><tbody>
            {LIGNES.map(([k, l, u]) => <tr key={k} className="border-b"><td className="py-1">{l}</td><td className="py-1 text-right">{v.nutrition[k]} {u}</td></tr>)}
          </tbody></table></section>
        {v.recyclage && <section><h2 className="font-semibold mb-1">Tri</h2><p className="text-sm">{v.recyclage}</p></section>}
        <p className="text-xs text-stone-500 text-center">L'abus d'alcool est dangereux pour la santé. Consommez avec modération. Déconseillé aux femmes enceintes.</p>
      </div>
    </div>
  );
}
